'use strict';

angular.module('controllers').controller('pendingUsersCtrl', function (resources, $scope) {

	});

